export default __webpack_public_path__ + "static/meshmate-of-the-year-2020-957d77658b265fe4296f4e9dd18e91db.webp";